import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Linha das telas de Configurações: rótulo + explicação à esquerda, controle à
 * direita. Quebra em uma coluna em telas estreitas.
 */
export const LinhaConfig = ({
  titulo,
  descricao,
  htmlFor,
  children,
  className,
}: {
  titulo: ReactNode;
  descricao?: ReactNode;
  /** id do controle principal, para o rótulo focar nele. */
  htmlFor?: string;
  children: ReactNode;
  className?: string;
}) => (
  <div className={cn("flex flex-wrap border-b border-border-soft last:border-b-0", className)}>
    <div className="flex flex-[1_1_260px] flex-col gap-1 px-6 py-[18px]">
      <label htmlFor={htmlFor} className="text-sm font-semibold">
        {titulo}
      </label>
      {descricao && <p className="text-[13px] leading-normal text-muted-foreground">{descricao}</p>}
    </div>
    <div className="flex flex-[1.4_1_320px] flex-col justify-center gap-2.5 px-6 py-[18px]">{children}</div>
  </div>
);

/** Caixa cinza com o exemplo calculado ao lado de um controle. */
export const ExemploConfig = ({ children }: { children: ReactNode }) => (
  <p className="rounded-md bg-muted-soft px-2.5 py-2 text-xs leading-normal text-muted-foreground">{children}</p>
);
